import React from 'react';
import { useNavigate } from 'react-router-dom';
import { userAppContext } from '../../../../context/Context';
import { UserAppContextType } from '../../../../router/types';

export const LinksExamples = () => {
  const navigate = useNavigate();
  const { restrictSources } = userAppContext() as unknown as UserAppContextType;

  const examplesData = [
    { label: 'Obesity', view: 'DISEASES', ident: 'C0028754', tab: 'GDA' },
    { label: 'LEPR', view: 'GENES', ident: '3953', tab: 'GDA' },
    { label: 'rs121913279', view: 'VARIANTS', ident: 'rs121913279', tab: 'VDA' },
    { label: 'Streptozocin', view: 'CHEMICALS', ident: 'CHEMBL1651906', tab: 'GDA' },
  ];

  const handleClick = ({ view, ident, tab }: { view: string; ident: string; tab: string }) => {
    const source = restrictSources === 'CURATED' ? 'CURATED' : 'ALL';

    navigate({
      pathname: '/search',
      search: `?view=${view}&idents=${ident}&source=${source}&tab=${tab}`,
    });
  };

  return (
    <div className="mt-3">
      <span>Examples:</span>
      {examplesData.map((example, index) => (
        <span
          key={index}
          className="example-responsive"
          onClick={() => handleClick({ view: example.view, ident: example.ident, tab: example.tab })}
        >
          {example.label} <i className="pl-1 bi-box-arrow-right"></i>
        </span>
      ))}
    </div>
  );
};
